import React from 'react';
import { addContentPath } from '../../util/pathUtil';
import Header from './Common/header';
import './css/index';

export default class Content_newNotice extends React.Component {
    render() {
        const { data = {}, eid } = this.props;
        return (
            <div className="item" id={`item_${eid}`}>
                <Header ecId={`${this && this.props && this.props.ecId || ''}_Header@53pxm0`} data={data} eid={eid} />
                <div className="content" id={`content_${eid}`}>
                    <div className="content_view">
                        <div className="ant-spin-nested-loading">
                            <div className="ant-spin-container">
                                <div className="tabContant" id="tabcontant_583">
                                    <div className="newnotice-add-Carousel">
                                        <div className="portal-element-newnotice-item">
                                            <div className="portal-element-newnotice-item-img">
                                                <img src={addContentPath('/page/resource/userfile/image/elementPrew/picture/Hindustry1.png')} alt="" />
                                            </div>
                                            <div className="portal-element-newnotice-item-content" style={{ width: 'calc(100% - 107px)' }}>
                                                <div className="portal-element-newnotice-item-title">千人共聚，泛微新一代移动办公平台体验会走入深圳</div>
                                                <div className="portal-element-newnotice-item-summary">今天，泛微新一代移动办公平台体验会落地深圳，千人共同体验泛微新一代“智能化、平台化、全程电子化”的OA系统产品。 深圳作为一线城市，是全国经济中心之一，聚集了大批优秀行业伙伴，信息化需求旺盛。大会现场人山人海，座无虚席。</div>
                                            </div>
                                        </div>
                                        <div className="portal-element-newnotice-item">
                                            <div className="portal-element-newnotice-item-img"><img src={addContentPath('/page/resource/userfile/image/elementPrew/picture/Hindustry2.png')} alt="" /></div>
                                            <div className="portal-element-newnotice-item-content" style={{ width: 'calc(100% - 107px)' }}>
                                                <div className="portal-element-newnotice-item-title">泛微OA鲲鹏伙伴大会走入东莞，共聚共创共享</div>
                                                <div className="portal-element-newnotice-item-summary">东莞，又称“莞城”，广东省地级市，全国5个不设区的地级市之一，是广东重要的交通枢纽和外贸口岸。 刚刚，泛微鲲鹏伙伴大会落地东莞，当地伙伴齐聚富力万达文华大酒店，共商OA系统普及。</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="element_prew_notice_new">
                                        <div className="wea-browser customized ">
                                            <div>
                                                <div className="cursor-pointer">
                                                    <div className="portal-element-newnotice-add"><img src={addContentPath('/page/element/newNotice/resource/image/new.png')} title="添加公告" alt="" /></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/Content_newNotice.js